(function() {
  'use strict';
  
  class HideSoldVariants {
    constructor() {
      this.variants = [];
      this.initialized = false;
      this.debounceTimer = null;
      
      this.applyInitialStyling();
      this.init();
    }
    
    applyInitialStyling() {
      const style = document.createElement('style');
      style.textContent = `
        /* Immediate strike-through removal */
        [data-value].disabled::after,
        .paint-option__item.disabled::after,
        .selector-wrapper .disabled::after {
          display: none !important;
        }
        /* Immediate greyed-out effect for disabled options */
        [data-value].disabled,
        .paint-option__item.disabled {
          opacity: 0.85 !important;
          filter: grayscale(60%) !important;
          text-decoration: none !important;
        }
      `;
      document.head.appendChild(style);
    }
    
    init() {
      console.log('HideSoldVariants: Initializing...');
      
      this.loadVariantData();
      
      if (!this.variants || this.variants.length === 0) {
        console.warn('HideSoldVariants: No variant data');
        return;
      }
      
      console.log(`HideSoldVariants: Loaded ${this.variants.length} variants`);
      
      this.processVariants();
      
      this.setupEventListeners();
      
      // Multiple retries for dynamic content
      [100, 300, 600, 1000].forEach(delay => {
        setTimeout(() => this.debouncedProcess(), delay);
      });
      
      this.initialized = true;
      console.log('HideSoldVariants: Initialized');
    }
    
    loadVariantData() {
      if (window.productVariantsData) {
        this.variants = window.productVariantsData;
      }

      else if (window.product && window.product.variants) {
        this.variants = window.product.variants.map(v => ({
          ...v,
          option1: v.option1,
          option2: v.option2,
          option3: v.option3,
          available: v.available,
          exclude_from_hide: v.metafields?.exclude_from_hide || false
        }));
      }
    }
    
    getCurrentSelections() {
      const selections = {};
      for (let i = 1; i <= 3; i++) {
        const selected = document.querySelector(`[data-index="option${i}"] input[type="radio"]:checked`);
        if (selected) {
          selections[`option${i}`] = selected.value;
        }
      }
      return selections;
    }
    
    getMatchingVariants(optionNum, optionValue, selections) {
      const testSelections = { ...selections };
      testSelections[`option${optionNum}`] = optionValue;
      
      return this.variants.filter(variant => {
        for (let i = 1; i <= optionNum; i++) {
          const variantValue = variant[`option${i}`];
          const selectedValue = testSelections[`option${i}`];
          
          if (selectedValue && variantValue !== selectedValue) {
            return false;
          }
        }
        return true;
      });
    }
    
    shouldHideOption(optionNum, optionValue, selections) {
      const matchingVariants = this.getMatchingVariants(optionNum, optionValue, selections);
      
      if (matchingVariants.length === 0) {
        return true;
      }
      
      const allSoldOut = matchingVariants.every(v => !v.available);
      
      const anyExcluded = matchingVariants.some(v => v.exclude_from_hide);
      const allowExclusions = window.theme?.settings?.allow_excluded_variants !== false;
      
      if (anyExcluded && allowExclusions) {
        return false;
      }
      
      return allSoldOut;
    }
    
    processVariants() {
      const selections = this.getCurrentSelections();
      
      for (let optionNum = 1; optionNum <= 3; optionNum++) {
        this.processOption(optionNum, selections);
      }
    }
    
    processOption(optionNum, selections) {
      const optionKey = `option${optionNum}`;
      const wrapper = document.querySelector(`[data-index="${optionKey}"]`);
      
      if (!wrapper) return;
      
      const options = wrapper.querySelectorAll('[data-value]');
      let hiddenCount = 0;
      
      options.forEach(option => {
        const value = option.dataset.value;
        const shouldHide = this.shouldHideOption(optionNum, value, selections);
        
        const matchingVariants = this.getMatchingVariants(optionNum, value, selections);
        const allSoldOut = matchingVariants.length > 0 && matchingVariants.every(v => !v.available);
        const anyExcluded = matchingVariants.some(v => v.exclude_from_hide);
        const allowExclusions = window.theme?.settings?.allow_excluded_variants !== false;
        
        if (shouldHide) {
          if (option.style.display !== 'none') {
            option.style.display = 'none';
            option.style.visibility = 'hidden';
            option.dataset.hiddenBySoldout = 'true';
            hiddenCount++;
          }

          option.classList.remove('excluded-sold-out');
          option.removeAttribute('data-excluded-sold-out');
        } else {
          if (option.style.display === 'none') {
            option.style.display = '';
            option.style.visibility = '';
            delete option.dataset.hiddenBySoldout;
          }
          
          if (allSoldOut && anyExcluded && allowExclusions) {
            option.setAttribute('data-excluded-sold-out', 'true');
            option.classList.add('excluded-sold-out');
          } else {
            option.classList.remove('excluded-sold-out');
            option.removeAttribute('data-excluded-sold-out');
          }
        }
      });
      
      if (hiddenCount > 0) {
        console.log(`Hidden ${hiddenCount} options for ${optionKey}`);
      }
    }
    
    debouncedProcess() {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(() => {
        this.processVariants();
      }, 50);
    }
    
    setupEventListeners() {
      document.addEventListener('change', (e) => {
        if (e.target.matches('[data-index^="option"] input[type="radio"]')) {
          this.debouncedProcess();
        }
      });
      
      document.addEventListener('variantChange', () => {
        this.debouncedProcess();
      });
      
      const observer = new MutationObserver(() => {
        this.debouncedProcess();
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }
  
  window.HideSoldVariants = new HideSoldVariants();
})();